/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { observer } from 'mobx-react';
import Link from '@react/react-spectrum/Link';
import Button from '@react/react-spectrum/Button';
import Config from '../../../stores/config';
import { interpretKey } from '../../../utils/eventUtil';
import TranslationUtil from '../../../utils/translation';
import './index.scss';

const onHelp = (e) => {
    e.preventDefault();
    Config.linkCallbacks.downloadErrorHelp(e);
};

export default observer(() => (
    <div className="app-download-err">
        <h4 className="header">
            {TranslationUtil.getMessage('ccx.downloadError.title')}
        </h4>
        <div className="description">
            {TranslationUtil.getMessage('ccx.downloadError.description')}
            {
                Config.linkCallbacks.downloadErrorHelp && (
                    <Link
                        tabIndex={0}
                        variant="quiet"
                        onKeyDown={interpretKey({
                            onEnter: [onHelp, true],
                        })}
                        onClick={onHelp}>
                        {TranslationUtil.getMessage('ccx.downloadError.help')}
                    </Link>
                )
            }
        </div>
        {
            Config.appReloadCallback && (
                <Button variant="primary" onClick={Config.appReloadCallback}>
                    {TranslationUtil.getMessage('ccx.downloadError.reload')}
                </Button>
            )
        }
    </div>
));
